// src/config.ts

// http://localhost:4000/
export const API_CONFIG = {
  BASE_URL: "https://crew-fireworks-api.fly.dev/api",
  // BASE_URL: "http://localhost:4000/api",
};
